export function getCookie(name) {
  if (typeof document === 'undefined') return null
  const cookie = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
  return cookie ? cookie[2] : null
}

export function setCookie(name, value) {
  const now = new Date()
  const expireDate = new Date(
    now.getFullYear() + 1,
    now.getMonth(),
    now.getDay()
  )
  if (typeof document === 'undefined') return null
  const cookie = `${name}=${value};expires=${expireDate.toGMTString()};path=/`
  document.cookie = cookie
  return cookie
}
